import { toast } from "react-toastify";
import Chat from "../PureComponents/Chat";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RenderChat = () => {
    // const location = useLocation();
    // const navigate = useNavigate();
  
    // useEffect(() => {
    //   const message = location.state?.toastMessage;
    //   const type = location.state?.toastType || "info";
  
    //   if (message) {
    //     console.log((message))
    //     toast(message, { type,  toastId: "chat-toast", });
  
    //     // ✅ Clear the state so it doesn't trigger again
    //     navigate(".", { replace: true, state: {} });
    //   }
    // }, [location.state, navigate]);
  return (
    <>
      <Chat />
    </>
  );
};

export default RenderChat;
